import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=3ffd3976&scoped=true&"
import script from "./GeneralTab.vue?vue&type=script&lang=js&"
export * from "./GeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=3ffd3976&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd3976",
  null
  
)

export default component.exports